import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import StudentProfileComp from './StudentProfileComp'

function StudentProfile() {
  return (
    <div className='mainContainer'>
      <LeftmenuIn />
      <div className='theMainContainer'>
        <DashnavIn />
        <StudentProfileComp />
      </div>
    </div>
  )
}

export default StudentProfile
